import { ReactNode } from "react";
import { StyledLink } from "components/OrderDetailsSummary/orderDetailsSummary.styles.ts";
import { models } from "types/api/viewModels.ts";

const placeholderRegexp = /(\{\w+\})/;
const templateKeyRegexp = /[\{\}]/g;

export const getLegalContent = (
	text: string | null | undefined,
	placeholders: models["LegalNoticeViewModel"]["placeholders"]
) =>
	text?.split(placeholderRegexp).reduce((accum: ReactNode[], part) => {
		const placeholderArray = Object.entries(placeholders ?? {});
		const match = part.match(placeholderRegexp);

		if (match) {
			const matchKey = match[0]?.replace(templateKeyRegexp, "");
			const found = placeholderArray.find((holder) => holder[0] === matchKey)?.[1];

			if (found && found?.url) {
				const url = found.url ?? "";
				accum.push(
					<StyledLink
						href={found.isMailTo ? `mailto:${url}` : url}
						target="_blank"
						rel="noreferrer"
					>
						{found.displayText}
					</StyledLink>
				);
			} else if (found?.displayText) {
				accum.push(found.displayText);
			}
		} else {
			accum.push(part);
		}

		return accum;
	}, []);
